import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Banner, BannerAction } from "@types";
import { VisibleSlide } from "../carousel/carousel.component";

export interface VisibleBanner {
  instanceId: string;
  banner: Banner;
}

export interface BannerActionEvent {
  banner: Banner;
  action: BannerAction;
}

@Component({
  selector: "app-banner-carousel",
  templateUrl: "./banner-carousel.component.html",
  styleUrls: ["./banner-carousel.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class BannerCarouselComponent {
  @Input() public banners: Banner[] = [];

  @Output() public dismiss = new EventEmitter<Banner>();
  @Output() public action = new EventEmitter<BannerActionEvent>();
  @Output() public visible = new EventEmitter<VisibleBanner>();

  public handleSlideVisible(visibleSlide: VisibleSlide) {
    const banner = this.banners.find((b) => b.id === visibleSlide.slideKey);
    this.visible.emit({
      instanceId: visibleSlide.instanceId,
      banner,
    });
  }

  public handleBannerAction(banner: Banner, action: BannerAction) {
    this.action.emit({ banner, action });
  }
}
